import React from "react";
import RBACWrapper from "../RBACWrapper";
import RBACProps from "./withRBAC.types";

function withRBAC<T extends object>(
  WrappedComponent: React.ComponentType<T>,
  rbacProps: RBACProps
) {
  const ComponentWithRBAC = (props: T) => {
    return (
      <RBACWrapper {...rbacProps}>
        <WrappedComponent {...props} />
      </RBACWrapper>
    );
  };
  return ComponentWithRBAC;
}

export default withRBAC;
